var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "550px",
    height: "407px",
    viewBox: "0 0 550 407",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ksztalty-kolor@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "24.4897959%",
    x2: "54.2475043%",
    y2: "70.4088253%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FDFE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF8FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9053879,36.3502729 C123.949788,0.925467246 528.459353,-39.1980125 521.837039,79.5324458 C514.445254,212.058609 518.54014,306.1192 447.46562,321.520309 C432.006357,324.870171 380.362537,337.335282 319.074277,347.207133 C307.541213,349.064792 266.228406,354.633989 257.466956,355.576947 C162.243373,365.825457 64.7293971,362.274044 49.3367828,307.683389 C14.3633986,183.648582 -0.693834582,63.9637131 53.9053879,36.3502729 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.0%",
    y: "-8.3%",
    width: "111.9%",
    height: "116.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BOI---L---01.1",
    transform: "translate(-444.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(446.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ksztalty-kolor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7404182,11.8116064 C59.3224679,-7.69640645 459.954023,3.34895645 456.306302,68.7323867 C454.203092,106.431282 475.341306,180.259398 409.17229,260.584052 C347.245994,335.758334 305.200359,325.001281 254.092322,333.051037 C164.312416,347.191793 34.3328743,218.34866 18.2239265,161.231478 C-1.04020948,92.9270073 -9.33407621,27.0179946 20.7404182,11.8116064 Z",
    id: "Rectangle-Copy",
    fill: "#29B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.483115,24.1912157 C239.127021,4.65114871 551.539214,-8.83189985 547.885644,56.6589635 C545.779063,94.4198028 542.16928,180.796904 475.89418,261.253541 C413.868602,336.551343 305.701829,325.07839 254.511855,333.141373 C164.588011,347.305364 86.1457856,205.120368 70.0110116,147.909336 C50.7159908,79.4926321 170.360405,39.4225899 200.483115,24.1912157 Z",
    id: "Rectangle-Copy-12",
    fill: "#00497E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.508336,100.991332 C208.106811,81.4933357 443.914508,-18.3163984 440.265233,47.0334611 C438.161128,84.7130002 475.576644,180.699215 409.379459,260.982627 C347.426801,336.118311 233.420368,378.223949 182.290574,386.269572 C92.4724476,400.403068 40.9217131,236.018335 24.8059075,178.93048 C5.53357047,110.661079 139.421038,116.189913 169.508336,100.991332 Z",
    id: "Rectangle-Copy-11",
    fill: "#FDC420"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.0187f43d2ef7204b787326dbe9f5817b.svg";
export { ForwardRef as ReactComponent };